<app-single-insurant-form
    [insurants]="insurants"
    [isOpen]="isOpen"
    [isFirstStep]="isFirstStep"
    (prev)="prev.emit($event)"
    (next)="next.emit($event)"
></app-single-insurant-form>
